import axios from "axios";
import { GET_ACHIEVEMENTS_BY_STUDENTID } from "./types";
const keys = require("../config/keys");

export const getAchievementsByStudentId = StudentId => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetAchievementsByStudentId?StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ACHIEVEMENTS_BY_STUDENTID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getAchivementsByStudentId.js